import React, { useEffect, useContext, useState, useRef } from 'react';
import { AccountContext } from '../../context/AccountContext';
import axios from 'axios';
import { POOl_RANKING } from '../../api/api';
import Loading from '../Loading/Loading';
import { useToast } from '@chakra-ui/react';
import RankingList from '../Common/Ranking/RankingList';

const PoolRanking = () => {
  const { user } = useContext(AccountContext);
  const [isLoading, setIsLoading] = useState(true);
  const [poolRankingList, setPoolRankingList] = useState([]);
  const toast = useToast();
  const source = useRef(axios.CancelToken.source()).current;

  useEffect(() => {
    fetchAllPoolRanking(user.email);

    return () => {
      source.cancel(); // Cancel any ongoing requests on component unmount
    };
  }, [user.email, source]);

  const fetchAllPoolRanking = async (authorEmail) => {
    setIsLoading(true);
    try {
      const response = await POOl_RANKING.get(
        `get-all-pool-ranking-items?author_email=${authorEmail}`,
        { cancelToken: source.token }
      );
      setPoolRankingList(response.data);
    } catch (error) {
      console.error(error);
      toast({
        title: error.message,
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return <Loading loading={isLoading} />;
  }

  return (
    <RankingList
      rankingList={poolRankingList}
      rankingListType="Resume Pool Ranking List"
      routePath={'/home/pool-ranking/progress'}
    />
  );
};

export default PoolRanking;
